<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <el-tabs v-model="activeName">
      <el-tab-pane label="身份校验" name="identityCheck">
        <identity-check/>
      </el-tab-pane>
      <el-tab-pane label="人脸认证" name="faceVerification">
        <face-verification :activeName="activeName"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import IdentityCheck from './components/IdentityCheck.vue'
import FaceVerification from './components/FaceVerification.vue'

export default {
  name: 'white-list',
  components: { IdentityCheck, FaceVerification },
  props: [],
  data () {
    return {
      activeName: 'identityCheck'
    }
  },
  async created () {
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    // handleClick (tab, event) {

    // }
  }
}
</script>
